import { useEffect } from "react";
import { changePageTitle } from "../ui/ui-util";

export const PageMeta = ({ title }: { title: string }) => {
  useEffect(() => changePageTitle(title), [title]);
  return null;
};
